import Http from "../common/utils/Http";

export const faqList = async () => {
    try {
        return await Http.get('home/content/faq');
    } catch (error) {
        throw error;
    }
}
